<template>
  <div v-if="isShow()" id="time-action">
    <div class="card">
      <div class="card-body">
        <div class="divide-y">
          <div class="row">
            <div class="col-6">
              <label class="form-label">Дата начала</label>
              <Datepicker auto-apply @update:modelValue="onChangeDateStart" v-model="fields.start" locale="ru" format="dd.MM.yyyy" placeholder="Выбрать дату" :enable-time-picker="false" @cleared="onClearStart"/>
              <div class="row g-2 mt-1px" v-show="fields.start !== null">
                <div class="col-6">
                  <select class="form-select" v-model="fields.startHour" @change="onChangeTimeStart">
                    <option :value="index" v-for="(item, index) in getHours()" :key="index">{{ item }}</option>
                  </select>
                </div>
                <div class="col-6">
                  <select class="form-select" v-model="fields.startMinute" @change="onChangeTimeStart">
                    <option :value="index" v-for="(item, index) in getMinutes()" :key="index">{{ item }}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-6">
              <label class="form-label">Дата конца</label>
              <Datepicker auto-apply @update:modelValue="onChangeDateEnd" v-model="fields.end" locale="ru" format="dd.MM.yyyy" placeholder="Выбрать дату" :enable-time-picker="false" @cleared="onClearEnd"/>
              <div class="row g-2 mt-1px" v-show="fields.end !== null">
                <div class="col-6">
                  <select class="form-select" v-model="fields.endHour" @change="onChangeTimeEnd">
                    <option :value="index" v-for="(item, index) in getHours()" :key="index">{{ item }}</option>
                  </select>
                </div>
                <div class="col-6">
                  <select class="form-select" v-model="fields.endMinute" @change="onChangeTimeEnd">
                    <option :value="index" v-for="(item, index) in getMinutes()" :key="index">{{ item }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {defineComponent, onMounted, reactive, ref} from "vue"
import Datepicker from "@/plugins/datepicker"
import DT from "@/services/DT";

export default defineComponent({
  name: "TimeAction",
  components: {Datepicker},
  props: {
    payload: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, {emit}) {
    let show = ref(false)

    const fields = reactive({
      start: null,
      startHour: 0,
      startMinute: 0,
      end: null,
      endHour: 23,
      endMinute: 59,
    })

    onMounted(async () => {
      updateFields(props.payload)

      markUnshow()
      markShow()
    })

    function updateFields(query) {

      fields.start = query.start
      if (fields.start !== null) {
        let d = new DT(query.start)
        fields.startHour = d.getHour()
        fields.startMinute = d.getMinutes()
      }

      fields.end = query.end
      if (fields.end !== null) {
        let d = new DT(query.end)
        fields.endHour = d.getHour()
        fields.endMinute = d.getMinutes()
      }
    }

    function markShow() {
      show.value = true
    }

    function markUnshow() {
      show.value = false
    }

    function isShow() {
      return show.value === true
    }

    function onChangeDateStart(val) {
      fields.start = val
      // todo тут должно быть (true)
      onChangeDatetime(false)
    }

    function onChangeTimeStart() {
      if (fields.start === null) {
        return false
      }
      // todo тут должно быть (true)
      onChangeDatetime(false)
    }

    function onClearStart() {
      fields.start = null
      fields.startHour = 0
      fields.startMinute = 0
      onChangeDatetime(false)
    }

    function onChangeDateEnd(val) {
      fields.end = val
      // todo тут должно быть (true)
      onChangeDatetime(false)
    }

    function onChangeTimeEnd() {
      if (fields.end === null) {
        return false
      }
      // todo тут должно быть (true)
      onChangeDatetime(false)
    }

    function onClearEnd() {
      fields.end = null
      fields.endHour = 23
      fields.endMinute = 59
      onChangeDatetime(false)
    }

    function onChangeDatetime(checkValidate = true) {
      if (checkValidate === true) {
        //validate(change)
      } else {
        change()
      }
    }

    function change() {
      let datetimeStart = null
      let datetimeEnd = null

      if (fields.start !== null) {
        datetimeStart = new DT(fields.start).startTimeOfDay()
        datetimeStart.setHour(fields.startHour)
        datetimeStart.setMinute(fields.startMinute)
        datetimeStart.setSec(0)
      }

      if (fields.end !== null) {
        datetimeEnd = new DT(fields.end).startTimeOfDay()
        datetimeEnd.setHour(fields.endHour)
        datetimeEnd.setMinute(fields.endMinute)
        datetimeEnd.setSec(0)
      }

      emit("onChange", {
        start: datetimeStart ? datetimeStart.get("%Y-%M-%D %H:%I:%S") : null,
        end: datetimeEnd ? datetimeEnd.get("%Y-%M-%D %H:%I:%S") : null,
      })
    }

    function getHours() {
      let items = []

      let i = 0;
      while (i <= 23) {
        items[i] = i.toString().padStart(2, "0")
        i++;
      }

      return items
    }

    function getMinutes() {
      let items = []

      let i = 0;
      while (i <= 59) {
        items[i] = i.toString().padStart(2, "0")
        i++;
      }

      return items
    }

    return {
      isShow,
      fields,
      onChangeDateStart,
      onChangeTimeStart,
      onClearStart,
      onChangeDateEnd,
      onChangeTimeEnd,
      onClearEnd,
      getHours,
      getMinutes,
    }
  }
})
</script>

<style scoped>
#time-action .mt-1px {
    margin-top: 1px;
}
</style>
